import styled from 'styled-components';

export const PageHeader = styled.div`
	text-align: center;
	margin-bottom: 2em;
`;
